import { ProductNameType } from "graphql/generated";

export const TELE_CONSULT_PRODUCT = [
  ProductNameType.Teleconsultation,
  ProductNameType.TeleconsultNoEval
];
